import { Component, inject, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { PathwayFacade } from '@app/store/pathway';
import { EntityListComponent, UnavailableComponent } from '@shared/components';

@Component({
    selector: 'app-pathway-view-modal',
    templateUrl: './view.component.html',
    styleUrls: ['./view.component.css'],
    imports: [TranslateModule, EntityListComponent, UnavailableComponent],
})
export class ViewComponent implements OnDestroy {
    private readonly router = inject(Router);
    private readonly route = inject(ActivatedRoute);
    private readonly pathwayFacade = inject(PathwayFacade);

    readonly pathway = this.pathwayFacade.pathway;
    readonly loading = this.pathwayFacade.loading;
    readonly error = this.pathwayFacade.error;
    constructor() {
        const id = this.route.parent?.snapshot.params['id'];
        if (id) {
            this.pathwayFacade.getPathway(id);
        }
    }

    ngOnDestroy(): void {
        this.pathwayFacade.clear();
    }

    close(): void {
        this.router.navigate([{ outlets: { modal: null } }]);
    }
}
